module.exports = __webpack_public_path__ + "static/media/Close.08ee29fa.svg";